import React from "react";

import {
  faBold,
  faItalic,
  faList,
  faListOl,
  faStrikethrough,
  faUnderline,
} from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import cn from "classnames";

import { stopEvents } from "@mapmycustomers/shared/util/browser";

import Divider from "../../../../Divider";
import ElementType from "../../../../type/slate/ElementType";
import TextType from "../../../../type/slate/TextType";
import ImageUploadCallback from "../../type/ImageUploadCallback";
import LinkInsert from "../LinkInsert";

import ClearStyles from "./ClearStyles";
import ElementAlignmentToggler from "./ElementAlignmentToggler";
import ElementToggler from "./ElementToggler";
import HistoryControl from "./HistoryControl";
import ImageInsert from "./ImageInsert";
import IndentControl from "./IndentControl";
import TextColorToggler from "./TextColorToggler";
import TextSizeSelector from "./TextSizeSelector";
import TextToggler from "./TextToggler";
import styles from "./Toolbar.module.scss";

interface ToolbarPropsProps {
  extraMargin?: boolean;
  onImageUpload: ImageUploadCallback;
  showInsertLink?: boolean;
}

const Toolbar = ({ extraMargin, onImageUpload, showInsertLink }: ToolbarPropsProps) => {
  return (
    <div
      className={cn(styles.container, { [styles.extraMargin]: extraMargin })}
      onClick={stopEvents}
    >
      <TextSizeSelector />
      <Divider className={styles.divider} type="vertical" />
      <TextToggler
        tooltipTranslationString="ui.emailBody.toolbar.bold"
        value={{
          label: <FontAwesomeIcon icon={faBold} />,
          value: TextType.BOLD,
        }}
      />
      <TextToggler
        tooltipTranslationString="ui.emailBody.toolbar.italic"
        value={{
          label: <FontAwesomeIcon icon={faItalic} />,
          value: TextType.ITALIC,
        }}
      />
      <TextToggler
        tooltipTranslationString="ui.emailBody.toolbar.underline"
        value={{
          label: <FontAwesomeIcon icon={faUnderline} />,
          value: TextType.UNDERLINE,
        }}
      />
      <TextColorToggler />
      <Divider className={styles.divider} type="vertical" />
      <ElementAlignmentToggler />
      <ElementToggler
        tooltipTranslationString="ui.emailBody.toolbar.bulleted"
        value={{
          label: <FontAwesomeIcon icon={faList} />,
          value: ElementType.BULLETED_LIST,
        }}
      />
      <ElementToggler
        tooltipTranslationString="ui.emailBody.toolbar.numbered"
        value={{
          label: <FontAwesomeIcon icon={faListOl} />,
          value: ElementType.NUMBERED_LIST,
        }}
      />
      <Divider className={styles.divider} type="vertical" />
      <IndentControl offset={-1} />
      <IndentControl offset={1} />
      <Divider className={styles.divider} type="vertical" />
      <ImageInsert onImageUpload={onImageUpload} />
      {showInsertLink && <LinkInsert />}
      <Divider className={styles.divider} type="vertical" />
      <TextToggler
        tooltipTranslationString="ui.emailBody.toolbar.strikethrough"
        value={{
          label: <FontAwesomeIcon icon={faStrikethrough} />,
          value: TextType.STRIKE,
        }}
      />
      <Divider className={styles.divider} type="vertical" />
      <ClearStyles />
      <Divider className={styles.divider} type="vertical" />
      <HistoryControl />
      <HistoryControl redo />
    </div>
  );
};

export default Toolbar;
